module.exports = __webpack_public_path__ + "img/time-wait-icon.6c4f389c.svg";